import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f3fb60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-bar" }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    value: {},
    max: { default: 1 },
    smooth: { type: Boolean },
    failed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const widthRef = computed(() => {
  const pct = props.max > 0 ? (props.value / props.max) * 100 : 0
  return `${pct}%`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["progress-value", { smooth: _ctx.smooth, failed: _ctx.failed }]),
      style: _normalizeStyle({ width: widthRef.value })
    }, null, 6)
  ]))
}
}

})